const rateAvg = (rateData) => {
  const filtered = rateData.filter(item => item !== 0);
  if (filtered.length === 0) return 0;
  const sum = filtered.reduce((a, b) => a + b);
  const avg = sum / filtered.length;
  return Math.round((avg + Number.EPSILON) * 100) / 100;
}

const roundNo = (number) => {
  return Math.round((number + Number.EPSILON) * 100) / 100;
}

const titleColumns = [
  {
    title: 'Spare Name',
    dataIndex: 'sparePart',
    key: 'sparePart',
    // className: 'color-column',
    width: 200,
    //render: (sparepart) => sparepart && sparepart.name,
  },
  {
    title: 'Spare Type',
    dataIndex: 'sparePartType',
    key: 'sparePartType',
    // className: 'color-column',
    width: 150,
    //render: (sparepartType) => sparepartType && sparepartType.name,
  },
  {
    title: 'Unit',
    dataIndex: 'unit',
    key: 'unit',
    // render: () => 'Pc.'
  },
];

const commonCols = [
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    // className: 'color-column',
    width: 150,
    render: (location) => typeof location === 'string' ? location : (location ? location.name || '-' : '-'),
  },
  {
    title: 'Sub Location',
    dataIndex: 'subLocation',
    key: 'subLocation',
    // className: 'color-column',
    width: 150,
    render: (subLocation) => typeof subLocation === 'string' ? subLocation : (subLocation.name || '-'),
  },
  {
    title: 'Opening',
    children: [
      {
        title: 'Quantity',
        dataIndex: 'openQty',
        key: 'openQty',
        align: 'right',
        render: (openQty) => openQty ? Number(openQty).toFixed(2) : 0,
      },
      {
        title: 'Rate',
        dataIndex: 'openRate',
        key: 'openRate',
        align: 'right',
        render: (openRate) => openRate ? Number(openRate).toFixed(2) : 0,
      },
      {
        title: 'Total Value',
        dataIndex: 'openTotal',
        key: 'openTotal',
        align: 'right',
        render: (openTotal) => openTotal ? Number(openTotal).toFixed(2) : 0,
      },]
  },
  {
    title: 'Inwards',
    children: [
      {
        title: 'Quantity',
        dataIndex: 'inQty',
        key: 'inQty',
        align: 'right',
        render: (inQty) => inQty ? Number(inQty).toFixed(2) : 0,
      },
      {
        title: 'Rate',
        dataIndex: 'inRate',
        key: 'inRate',
        align: 'right',
        render: (inRate) => inRate ? Number(inRate).toFixed(2) : 0,
      },
      {
        title: 'Total Value',
        dataIndex: 'inTotal',
        key: 'inTotal',
        align: 'right',
        render: (inTotal) => inTotal ? Number(inTotal).toFixed(2) : 0,
      },]
  },
  {
    title: 'Outwards',
    children: [
      {
        title: 'Quantity',
        dataIndex: 'outQty',
        key: 'outQty',
        align: 'right',
        render: (outQty) => outQty ? Number(outQty).toFixed(2) : 0,
      },
      {
        title: 'Rate',
        dataIndex: 'outRate',
        key: 'outRate',
        align: 'right',
        render: (outRate) => outRate ? Number(outRate).toFixed(2) : 0,
      },
      {
        title: 'Total Value',
        dataIndex: 'outTotal',
        key: 'outTotal',
        align: 'right',
        render: (outTotal) => outTotal ? Number(outTotal).toFixed(2) : 0,
      },]
  },
  {
    title: 'Closing',
    children: [
      {
        title: 'Quantity',
        dataIndex: 'closeQty',
        key: 'closeQty',
        align: 'right',
        render: (closeQty) => closeQty ? Number(closeQty).toFixed(2) : 0,
      },
      {
        title: 'Rate',
        dataIndex: 'closeRate',
        key: 'closeRate',
        align: 'right',
        render: (closeRate) => closeRate ? Number(closeRate).toFixed(2) : 0,
      },
      {
        title: 'Total Value',
        dataIndex: 'closeTotal',
        key: 'closeTotal',
        align: 'right',
        render: (closeTotal) => closeTotal ? Number(closeTotal).toFixed(2) : 0,
      },]
  }
];

const openingCol = {
  title: 'Opening',
  children: [
    {
      title: 'Quantity',
      dataIndex: 'openQty',
      key: 'openQty',
      align: 'right',
      render: (openQty) => openQty ? Number(openQty).toFixed(2) : 0,
    },
    {
      title: 'Rate',
      dataIndex: 'openRate',
      key: 'openRate',
      align: 'right',
      render: (openRate) => openRate ? Number(openRate).toFixed(2) : 0,
    },
    {
      title: 'Total Value',
      dataIndex: 'openTotal',
      key: 'openTotal',
      align: 'right',
      render: (openTotal) => openTotal ? Number(openTotal).toFixed(2) : 0,
    },]
};

const closingCol = {
  title: 'Closing',
  children: [
    {
      title: 'Quantity',
      dataIndex: 'closeQty',
      key: 'closeQty',
      align: 'right',
      render: (closeQty) => closeQty ? Number(closeQty).toFixed(2) : 0,
    },
    {
      title: 'Rate',
      dataIndex: 'closeRate',
      key: 'closeRate',
      align: 'right',
      render: (closeRate) => closeRate ? Number(closeRate).toFixed(2) : 0,
    },
    {
      title: 'Total Value',
      dataIndex: 'closeTotal',
      key: 'closeTotal',
      align: 'right',
      render: (closeTotal) => closeTotal ? Number(closeTotal).toFixed(2) : 0,
    },]
};

let inventoryColumns = titleColumns.concat(commonCols);

module.exports = {rateAvg, roundNo, inventoryColumns, commonCols, openingCol, closingCol}
